import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { usePetitionSignatureCount } from './petitionStats';
import { useCampaignActionsEnabled } from './useCampaignActionsEnabled';

export function useNextStepButtonAction() {
	const {
		data: {
			petition: { slug, id },
		},
	} = usePetitionDetailsPageData();
	const {
		signatureCount: { displayed },
	} = usePetitionSignatureCount();
	const track = useTracking();
	const campaignActionsEnabled = useCampaignActionsEnabled();

	const baseLink = `/p/${slug}/psf/promote_or_share`;
	const comboLink = campaignActionsEnabled ? baseLink.concat('?allow_actions=true') : baseLink;

	const handleNextStepClick = useCallback(() => {
		void track('petition_next_step_click', {
			petition_id: `petition_${id}`,
			signatureCount: displayed,
			campaignActionsEnabled,
		});
	}, [track, id, campaignActionsEnabled, displayed]);

	return {
		data: { comboLink },
		action: { handleNextStepClick },
	};
}
